import { buildStrapiUrl } from '../utils/strapi-url';
import { fetchWithRetry } from './fetch-with-retry';

export async function fetchHeaderData(locale: string = 'en') {
  const params = new URLSearchParams({
    locale,
  });

  const res = await fetchWithRetry(buildStrapiUrl('/api/web/headers', params), {
    next: {
      revalidate: 1800,
      tags: [`header:${locale}`],
    },
  });

  // Must throw on failure: swallowing this used to cache pages without any
  // navigation for the whole ISR window.
  if (!res.ok) {
    throw new Error(`Failed to fetch header data (${res.status})`);
  }

  const data = await res.json();

  return data.data || [];
}
